// export const server = 'http://localhost:8000/api/v2';
export const server = "https://mahiautomobile-afroz-api.vercel.app/api/v2";
// export const backend_url = 'http://localhost:8000/';
export const backend_url = "https://mahiautomobile-afroz-api.vercel.app/";
